import { IfAbility } from '@efdigital/ll-addon-auth';
import LtiCreatePlatformModal from '@efdigital/ll-admin-v2/components/lti/create-platform-modal.gts';
import type { LtiConsumingPlatform } from '@efdigital/ll-admin-v2/data/types/lti';
import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';

import { ResultsTable } from '../results-table.gts';

interface Signature {
  Args: {
    clientId: string;
    platforms: LtiConsumingPlatform[];
    onPlatformCreated: (platform: LtiConsumingPlatform) => void;
  };
}

export default <template>
  <ResultsTable @data={{@platforms}}>
    <:header>
      <th>Learning Platform</th>
      <th>Description</th>
      <th>Issuer</th>
    </:header>
    <:row as |platform|>
      <tr>
        <td valign="middle">
          <LinkTo
            @route="library.clients.client.edit.lti-integrations.platform"
            @model={{platform.id}}
            class="fw-semibold"
          >{{platform.name}}
            <iconify-icon inline icon="ph:arrow-right" /></LinkTo>
        </td>
        <td valign="middle" class="text-muted">
          <div class="small text-muted">
            {{#if platform.description}}
              {{platform.description}}
            {{else}}
              &mdash;
            {{/if}}
          </div>
        </td>
        <td valign="middle">
          <code>{{platform.platformData.iss}}</code>
        </td>
      </tr>
    </:row>
    <:empty>
      <div class="alert alert-info" data-test-lti-platform-empty>
        <iconify-icon inline icon="ph:info" />
        No LMS platforms are configured for this client yet. Add a platform to
        begin LTI setup.
      </div>
    </:empty>
  </ResultsTable>

  <IfAbility @ability="lti-integrations" @atLeast="editor">
    <:if>
      <LtiCreatePlatformModal
        @clientId={{@clientId}}
        @onSaved={{@onPlatformCreated}}
      >
        <:trigger as |openModal|>
          <button
            type="button"
            class="btn btn-primary"
            {{on "click" openModal}}
            data-test-lti-add-platform
          >
            <iconify-icon inline icon="ph:plus" />
            Add platform
          </button>
        </:trigger>
      </LtiCreatePlatformModal>
    </:if>
  </IfAbility>
</template> satisfies TOC<Signature>;
